import { render, staticRenderFns } from "./NotificationsBar.vue?vue&type=template&id=c9012f9c"
import script from "./NotificationsBar.vue?vue&type=script&lang=js"
export * from "./NotificationsBar.vue?vue&type=script&lang=js"
import style0 from "./NotificationsBar.vue?vue&type=style&index=0&id=c9012f9c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports